export enum productTabsEnum {
	PENDING,
	APPROVED,
	REJECTED,
}

export enum productSubmitStatusEnum {
	NEW_PRODUCT,
	RESUBMITTED,
	EDITED_PRODUCT,
}
export enum stockAvailabilityEnum {
	INSTOCK = 0,
	OUTOFSTOCK = 1,
}

export enum productActivationStatus {
	ACTIVE = 0,
	INACTIVE = 1,
}

export enum gender {
	WOMEN,
	MEN,
}
export enum businessType {
	beautySalon,
	onlineStore,
}

export const productTabs: {
	name: string
	value: string
	count: number
	showCount: boolean
}[] = []

Object.keys(productActivationStatus).forEach((value: string) =>
	isNaN(+value)
		? productTabs.push({
				name: value,
				value: productActivationStatus[value as any],
				count: 0,
				showCount: false,
		  })
		: null
)
